import {Enumify} from "enumify-ts";
import InputType from "./InputType";
import QueryParamType from "./QueryParamType";
import { formatDateOnlyISO, formatDateOnlyDisplay } from "../util/FormatUtil";

class FilterParamType extends Enumify<FilterParamType>() {

    static CONSIGNMENT_REF_CONTAINS = new FilterParamType(
        "Delivery Reference Contains",
        "Delivery Reference",
        "refLike",
        InputType.TEXT,
        QueryParamType.TEXT
    );

    static CUSTOMER_REF_CONTAINS = new FilterParamType(
        "Your Reference Contains",
        "Your Reference",
        "customerRefLike",
        InputType.TEXT,
        QueryParamType.TEXT
    );

    static PICKUP_OR_DELIVER_TODAY = new FilterParamType(
        "Today's Deliveries",
        "",
        "pickupOrDeliveryDate",
        InputType.NONE,
        QueryParamType.DATE,
        formatDateOnlyDisplay,
        formatDateOnlyISO,
        () => new Date()
    );

    static COMPLETED_ON_OR_BEFORE = new FilterParamType(
        "Completed on or Before",
        "Date",
        "completedOnOrBefore",
        InputType.DATE,
        QueryParamType.DATE,
        formatDateOnlyDisplay,
        formatDateOnlyISO
    );

    static COMPLETED_ON_OR_AFTER = new FilterParamType(
        "Completed on or After",
        "Date",
        "completedOnOrAfter",
        InputType.DATE,
        QueryParamType.DATE,
        formatDateOnlyDisplay,
        formatDateOnlyISO
    );

    static HIRE_REF_CONTAINS = new FilterParamType(
        "Hire Reference Contains",
        "Hire Reference",
        "refLike",
        InputType.TEXT,
        QueryParamType.TEXT
    );

    static HIRED_FOR_DATE = new FilterParamType(
        "Hired for Date",
        "Hire Date",
        "hireDate",
        InputType.DATE,
        QueryParamType.DATE,
        formatDateOnlyDisplay,
        formatDateOnlyISO,
        () => new Date()
    )

    static _ = FilterParamType._closeEnum();

    constructor(
        public description: string,
        public placeholder: string,
        public queryParam: string,
        public inputType: InputType,
        public type: QueryParamType,
        public formatForDisplay = (val: string) => val,
        public formatForQueryParam = (val: string) => val,
        public defaultValue: () => any = () => null
    ) {
        super();
        this.description = description;
        this.placeholder = placeholder;
        this.queryParam = queryParam;
        this.inputType = inputType;
        this.type = type;
        this.formatForDisplay = formatForDisplay;
        this.formatForQueryParam = formatForQueryParam;
        this.defaultValue = defaultValue;
    }

}

export default FilterParamType;
